import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const BenefitsEducational = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important
                            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
            
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Enhanced Communication</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>
              Simplify the information about your learning programs and engage new students. With the combination of visual elements, sound, and
              movement, videos are more impactful for keeping your audience's attention than traditional methods. Help your learners to remember more
              of what they learn.
            </div>
          </div>
        </div>
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>Wider Reach</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              Video production for schools or universities can enhance additional accessibility to learning materials. Videos can be in any language,
              for an audience of any age, and also for any learning program. Availability, without time or platform exceptions, makes these videos
              more impactful tools.
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30 pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Multi-versatile Tool</h3>
          The format of this video allows you to use it on various platforms in various styles. Choose the style that best explains your learning
          content, from 2D or 3D animation to live-action or mixed media. Also, video format can explain any topic without any subject exception.
        </div>
      </Slider>
    </>
  );
};
export default BenefitsEducational;
